<template>
    <div class="x_page">
        <Ssdt />
    </div>
</template>

<script>
import Ssdt from './dp'

export default {
    //import引入的组件需要注入到对象中才能使用
    components: { Ssdt },
    data() {
    //这里存放数据
        return {

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(()=>{
           
        })
         window.onresize = ()=> {
            // let clientHeight = this.$refs['carousel_wrapper_div'].clientHeight
            // this.carousel_height = clientHeight+'px';
        };
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {
        
        window.onresize = null
    }, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.x_page {
    width: 100%;
    height: 100%;
    background:url('../../assets/banbidian/bk.jpg') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 40px;
}




</style>